import tips from '../../../assets/tips.png';
import Image from "../../../component/Image";
import classes from '../../../styles/mobie.module.css';
import {useEffect, useState} from "react";
import {requestGet} from "../../../utils/request";
import android from '../../../assets/android.png';
import {useRouter} from 'preact-router'

export default function Index() {
	const [isWeiXin, setWeiXin] = useState(false);
	const [{matches}] = useRouter();
	const [data, setData] = useState({});


	useEffect(() => {
		function isWeiXin() {
			const ua = window.navigator.userAgent.toLowerCase();
			if (ua.indexOf('micromessenger') !== -1) {
				return true
			} else {
				return false
			}
		}

		setWeiXin(isWeiXin());

		getStaticProps(matches).then(data=>{
			console.log('data',data)
			setData(data)
		});

	}, []);


	function downloadFile(url) {
		// 创建一个<a>元素
		const link = document.createElement('a');
		link.href = url;

		// 设置下载属性，这样浏览器会提示用户下载文件
		link.setAttribute('download', '');

		// 隐藏该链接
		link.style.display = 'none';

		// 添加到文档中
		document.body.appendChild(link);

		// 模拟点击链接以下载文件
		link.click();

		// 清理
		document.body.removeChild(link);
	}
	return (
		<div>
			<title>{data?.title}</title>
			{
				isWeiXin &&
				<div className={classes.shade}>
                <span className={classes['picture_tips']}>
                    <Image src={tips} width="9.35rem" height="3.675rem" alt=""/>
                </span>
					<div className={classes['tips_word']}>
						<p className={classes['tips_wors-top']}>{`1. 下载请点击右上角 "..." 按钮`}</p>
						<p className={classes['tips_wors-top']}>{`2. 选择 " 在浏览器中打开 "`}</p>
					</div>
				</div>
			}
			<div className={classes.container}>
				<div className={classes.title}>
					<Image width={200}
					       height={80}
					       src={`${process.env.PREACT_APP_STATIC_URL}/jeean-logo/jeean-cloud-logo-gov.svg`}
					       alt=""/>
					<p>{data?.des}</p>
				</div>
				<button
					className={classes.ewmButton}
					style={{
						background: data?.color,
					}}
				>
					<span   onClick={e=>{
						downloadFile(data?.url)
					}}>
						<Image width={20} height={20} src={android} alt="" style={{marginRight: 20}}/>
						点击下载App
					</span>
				</button>
			</div>
		</div>
	)
}


function getStaticProps(context) {
	const images = {
		'1': {
			color: '#3fa2ff',
			title: '极安企业端app下载页',
			des: '企业安全生产风险管理平台',

		},
		'5': {
			color: '#009688',
			title: '极安专家端app下载页',
			des: '安全机构风控服务管理平台',

		},
		'10': {
			color: '#22ADFF',
			title: '极安安全胶囊app下载页',
			des: '让安全成为一种习惯',

		},
		'23': {
			color: '#ffd63f',
			title: '极安企业端app下载页',
			des: '保险风控管理平台',
		},
	}
	if (context?.id === '10') {
		return new Promise(resolve => {
			resolve({
				url: `${process.env.PREACT_APP_BUNDLE_URL}/jeeancap/jeeancap.apk`,
				...images[context?.id],	terminalID: context?.id,
			})
		})
	} else {
		return requestGet(process.env.PREACT_APP_BASE_URL, '/app/latest/download/url', {terminalID: context?.id}).then(res => {
			const data = res.data;
			return {
				url: data?.url,
				...images[context?.id],
				terminalID: context?.id,
			}
		});
	}
}

